import _ from 'lodash';
import { useMemo } from 'react';

import { getTooltipText } from './utils';
import { SuperAgentLevelView } from '../../components/SuperAgentLevel/SuperAgentLevelView';
import { IAgentCardModerationInfo } from '../../types/agentCard';
import { useApplicationContext } from '../../utils/applicationContext';

type TSuperAgentLevelViewContainerProps = {
  moderationInfo: IAgentCardModerationInfo | null;
};

export const SuperAgentLevelViewContainer = ({ moderationInfo }: TSuperAgentLevelViewContainerProps) => {
  const showSuperAgent = _.get(moderationInfo, 'qualityLevelInfo.showSuperAgent', null);
  const showSuperHost = _.get(moderationInfo, 'qualityLevelInfo.showSuperHost', null);
  const levelName = _.get(moderationInfo, 'qualityLevelInfo.levelName', '');

  const { config } = useApplicationContext();

  const tooltipText = getTooltipText(config);

  const text = useMemo(() => {
    if (levelName) {
      return levelName;
    }

    if (showSuperAgent) {
      return 'Суперагент';
    }

    if (showSuperHost) {
      return 'Суперхост';
    }

    return '';
  }, [levelName, showSuperAgent, showSuperHost]);

  if (!showSuperAgent && !showSuperHost) {
    return null;
  }

  return <SuperAgentLevelView tooltipText={tooltipText} levelName={text} />;
};
